import Swiper, { Navigation } from "swiper";

export default {
    init() {
        if (document.querySelector('.swiper-posts-post')) {
            Array.from(document.querySelectorAll('.swiper-posts-post'))
                .forEach(el => {
                    let numberOfSlides = Array.from(el.querySelectorAll('.swiper-slide')).length;

                    el.swiper = new Swiper(el, {
                        modules: [Navigation],
                        slidesPerView: 1.2,
                        loop: false,
                        spaceBetween: 20,
                        breakpoints: {
                            768: {
                                slidesPerView: 'auto',
                                loop: numberOfSlides > 4,
                            }
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
                    });
                });
        }
    }
}
